import { ISignature } from "../../../../../common/types";

const getSignatureIndex = (signatures: ISignature[], currentBarIndex: number) => {
  return signatures.findIndex(signature => signature.bar === currentBarIndex);
};

export const getBarTotalLength = (signatures: ISignature[], currentBarIndex: number) => {
  if (currentBarIndex === 0) {
      return signatures[0].upbeat!;
  }
  let signature;
  do {
      signature = signatures[getSignatureIndex(signatures, currentBarIndex)];
      currentBarIndex--;
  } while (!signature);
  let barLength = signature.num * (4 / signature.den);
  return barLength;
};